module.exports = __webpack_public_path__ + "img/sharebg.59145c17.png";